import { loaderAction, setSlugsAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { api } from "../../helpers/api";
import { setLocalStorage } from "../../helpers/LocalStorage";

export const GetSlugsThunk = (args) => async (dispatch, getState) => {
    const { user } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        const response = await api({ data: formData, link: 'get_slugs' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            dispatch(setSlugsAction(response.data));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }
};